import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function DailyWins() {
  const data = promotionsData.find((promo) => promo.title === "Daily Wins")
  const { setShowEasterEgg } = useGlobalContext()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Daily Wins</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Daily Tournament & Weekly Wheel Drops</h1>
                <h2>
                  Daily Wins will run from 30th March 2026 to 28th March 2027
                  with total of ₱ 435,000,000 to be awarded across 12 levels.
                </h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>March 30, 2026 - March 28, 2027</span>
                </div>
              </div>

              <div className="promotion-tnc-mechanic-content">
                <strong>Level 1: Weekly Wheel Drops</strong>
                <ul>
                  <li>From: Mon, 30 March 2026, 20:00 (GMT+8)</li>
                  <li>To: Mon, 27 April 2026, 19:59 (GMT+8)</li>
                </ul>

                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Prize Pool</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>5</td>
                        <td>29,000</td>
                      </tr>
                      <tr>
                        <td>25</td>
                        <td>14,500</td>
                      </tr>
                      <tr>
                        <td>90</td>
                        <td>x50 Multiplier</td>
                      </tr>
                      <tr>
                        <td>280</td>
                        <td>x20 Multiplier</td>
                      </tr>
                      <tr>
                        <td>2,600</td>
                        <td>x10 Multiplier</td>
                      </tr>
                      <tr>
                        <td>30,000</td>
                        <td>x5 Multiplier</td>
                      </tr>
                      <tr>
                        <td>21,000</td>
                        <td>10 Free Spins</td>
                      </tr>
                      <tr>
                        <td>25,000</td>
                        <td>8 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <br />
                <strong>
                  Level 1: Daily Slot Tournaments – Largest Win From A Single
                  Spin Spin
                </strong>
                <ul>
                  <li>From: Mon, 30 March 2026, 20:00 (GMT+8)</li>
                  <li>To: Mon, 27 April 2026, 02:00 (GMT+8)</li>
                </ul>

                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Prize Pool</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>x500 Multiplier</td>
                      </tr>
                      <tr>
                        <td>2 – 5</td>
                        <td>x200 Multiplier</td>
                      </tr>
                      <tr>
                        <td>6 – 20</td>
                        <td>x50 Multiplier</td>
                      </tr>
                      <tr>
                        <td>21 – 200</td>
                        <td>x10 Multiplier</td>
                      </tr>
                      <tr>
                        <td>201 – 1,500</td>
                        <td>x5 Multiplier</td>
                      </tr>
                      <tr>
                        <td>1,501 – 3,000</td>
                        <td>10 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <br />
                <strong>Level 2: Weekly Wheel Drops</strong>
                <ul>
                  <li>From: Mon, 27 April 2026, 20:00 (GMT+8)</li>
                  <li>To: Mon, 25 May 2026, 19:59 (GMT+8)</li>
                </ul>

                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Prize Pool</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>5</td>
                        <td>29,000</td>
                      </tr>
                      <tr>
                        <td>25</td>
                        <td>14,500</td>
                      </tr>
                      <tr>
                        <td>90</td>
                        <td>x50 Multiplier</td>
                      </tr>
                      <tr>
                        <td>280</td>
                        <td>x20 Multiplier</td>
                      </tr>
                      <tr>
                        <td>2,600</td>
                        <td>x10 Multiplier</td>
                      </tr>
                      <tr>
                        <td>30,000</td>
                        <td>x5 Multiplier</td>
                      </tr>
                      <tr>
                        <td>21,000</td>
                        <td>10 Free Spins</td>
                      </tr>
                      <tr>
                        <td>25,000</td>
                        <td>8 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <br />
                <strong>
                  Level 2: Daily Slot Tournaments – Largest Win From A Single
                  Spin
                </strong>
                <ul>
                  <li>From: Mon, 27 April 2026, 20:00 (GMT+8)</li>
                  <li>To: Mon, 25 May 2026, 02:00 (GMT+8)</li>
                </ul>
                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Prize Pool</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>x500 Multiplier</td>
                      </tr>
                      <tr>
                        <td>2 – 5</td>
                        <td>x200 Multiplier</td>
                      </tr>
                      <tr>
                        <td>6 – 20</td>
                        <td>x50 Multiplier</td>
                      </tr>
                      <tr>
                        <td>21 – 200</td>
                        <td>x10 Multiplier</td>
                      </tr>
                      <tr>
                        <td>201 – 1,500</td>
                        <td>x5 Multiplier</td>
                      </tr>
                      <tr>
                        <td>1,501 – 3,000</td>
                        <td>10 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="promotion-tnc-cta">
                  <a
                    className="promotion-cta-btn"
                    href="https://pp88.asia/tl/promotion/daily-wins/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
